import { Link } from "react-router";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { EASE, Ink, VIEW } from "../bits";
import { EVENT } from "./event";
import "./GigPoster.css";

/* Variant C: a screen-printed gig poster. The movie poster is reprinted as a
   one-color cobalt plate on cream (its own title lettering faded out), with an
   oversized gold date printed slightly off-register across its edge and a
   rubber-stamped "Halloween movie night". */

export function EventGigPoster() {
  return <motion.div className="evg-wrap" initial={{ opacity: 0, y: 30, rotate: 0 }} whileInView={{ opacity: 1, y: 0, rotate: -1.5 }} viewport={VIEW} transition={{ duration: 0.6, ease: EASE }}>
    <Link to={EVENT.href} className="evg">
      <span className="evg-art">
        <span className="evg-plate"><img src={EVENT.poster} alt={EVENT.posterAlt} /></span>
      </span>
      <span className="evg-date" aria-hidden="true"><small>{EVENT.month}</small><b>{EVENT.day}</b></span>
      <span className="evg-body">
        <span className="evg-stamp">{EVENT.kicker}</span>
        <b className="evg-title">{EVENT.headline[0]} <i>{EVENT.film}</i> {EVENT.headline[1]}</b>
        <span className="evg-sub">{EVENT.title} · {EVENT.tagline.toLowerCase()}</span>
        <span className="evg-info">
          <span>{EVENT.weekday}, {EVENT.month} {EVENT.day} · {EVENT.time}</span>
          <span>{EVENT.venue}</span>
        </span>
        <span className="evg-cta-row">
          <span className="evg-cta">
            <span className="evg-cta-label">Get tickets · {EVENT.price} <ArrowRight size={16} aria-hidden="true" /></span>
            <svg viewBox="0 0 240 70" preserveAspectRatio="none" aria-hidden="true"><Ink d="M184 9 C 110 -3, 14 8, 8 37 C 2 66, 122 70, 202 60 C 250 52, 246 18, 196 8" delay={0.7} width={2.6} /></svg>
          </span>
          <span className="evg-note" aria-hidden="true">bring your<br />knitting!</span>
        </span>
      </span>
    </Link>
  </motion.div>;
}
